import { toast } from "sonner";

export function timeAgo(timestamp) {
    const now = Date.now();  // Get the current time in milliseconds
    const diff = now - timestamp;  // Calculate the difference in milliseconds
    
    const seconds = Math.floor(diff / 1000);  // Convert the difference to seconds
    const minutes = Math.floor(seconds / 60);  // Convert seconds to minutes
    const hours = Math.floor(minutes / 60);  // Convert minutes to hours
    const days = Math.floor(hours / 24);  // Convert hours to days
    
    // Return the result as a string
    if (days > 0) {
      return `${days} days ago`;
    }
    if (hours > 0) {
      return `${hours} hours ago`;
    }
    if (minutes > 0) {
      return `${minutes} minutes ago`;
    }
    return `${seconds} seconds ago`;
  }


 export  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard) {
      // Use the Clipboard API for modern browsers
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          toast.success('Copied to clipboard !')
        })
        .catch(err => {
          console.error('Error copying text: ', err);
        });
    } 
  };

  export function timeAgoIso(date) {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000); // Difference in seconds
  
    const seconds = diffInSeconds;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);
  
    if (seconds < 60) {
      return seconds === 1 ? "1 second ago" : `${seconds} seconds ago`;
    } else if (minutes < 60) {
      return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    } else if (hours < 24) {
      return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    } else if (days < 30) {
      return days === 1 ? "1 day ago" : `${days} days ago`;
    } else if (months < 12) {
      return months === 1 ? "1 month ago" : `${months} months ago`;
    } else {
      return years === 1 ? "1 year ago" : `${years} years ago`;
    }
  }





  export function getTimeWithTimeStamp() {
    const currentTimestamp = Date.now();  // Get current timestamp in milliseconds
    
    const date = new Date(currentTimestamp);
  
    // Format the date as MM/DD/YYYY
    const formattedDate = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
    
    // Format the time as HH:MM:SS
    const formattedTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
  
    return {
      timestamp: currentTimestamp,
      date: formattedDate,
      time: formattedTime
    };
  }

     export function calculateAmountToBuyInDollar (tokenPrice,investment) {
      
      let amountTobuyDollar = investment/tokenPrice
      return amountTobuyDollar
     }


     export function unixToDate (timestamp){
      const date = new Date(timestamp * 1000); // Convert to milliseconds
    
      // Get the hours, minutes, and seconds
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      
      // Determine AM or PM
      const ampm = hours >= 12 ? 'PM' : 'AM';
      
      // Convert to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (0 hours)
      
      // Format minutes and seconds with leading zeroes if needed
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
      const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
      
      // Return the formatted time
      return `${hours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
  }
  

  